import React, { useEffect, useState } from 'react';
import { HeaderBox, BookItemBox, BookTitleTypography, MainContentBox } from './MobileBookPage';
import { Box, IconButton, Typography, CircularProgress, Grid } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ArticlesService from '../../Services/Articles';
import articleIcon from '../../Images/Image/article.png';
import { useDownloadApp } from '../../Contexts/DownloadAppContext';

const MobileArticlesPage = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { setShowDownloadPopup } = useDownloadApp();
  const [articles, setArticles] = useState<any[]>([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArticles = async () => {
      setLoading(true);
      try {
        const response = await ArticlesService.getArticles(
          0, 50, false, "", "", "", "2", "", false
        );
        if (response?.status && response?.result) {
          setArticles(response.result.items || []);
          setTotalRecords(response.result.totalRecords || 0);
        }
      } catch (error) {
        console.error("Error fetching articles:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchArticles();
  }, []);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <HeaderBox>
        <IconButton onClick={() => navigate(-1)} sx={{ position: 'absolute', left: 16, top: 35, p: 0 }}>
          <ArrowBackIosIcon sx={{ color: "white", fontSize: '18px' }} />
        </IconButton>
        <IconButton onClick={() => navigate("/")} sx={{ position: 'absolute', left: 48, top: 35, p: 0 }}>
          <HomeOutlinedIcon sx={{ color: "white", fontSize: '24px' }} />
        </IconButton>
        <Typography variant="caption" sx={{ color: "#ffffffdd", opacity: 0.9, mb: 0.5 }}>
          {t("shrihari_tr")}
        </Typography>
        <Typography variant="h6" sx={{ color: "#ffffffdd", opacity: 0.9, fontSize: 15 }}>
          {t("Article_tr")}
        </Typography>
      </HeaderBox>

      <Box sx={{
        backgroundColor: '#f0f0f0',
        padding: '8px 16px',
        textAlign: 'center',
        borderBottom: '1px solid #e0e0e0',
      }}>
        <Typography variant="body2" sx={{ color: '#555', fontWeight: 500 }}>
          {t("Total_Records_tr")}: {totalRecords}
        </Typography>
      </Box>

      <MainContentBox>
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <CircularProgress />
          </Box>
        ) : articles.length === 0 ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <Typography sx={{ color: '#888' }}>{t("result_not_found_tr")}</Typography>
          </Box>
        ) : (
          <Grid container spacing={0}>
            {articles.map((article: any) => (
              <Grid item xs={12} key={article.id}>
                <BookItemBox
                  isGridView={false}
                  sx={{ margin: 0.3, padding: 1, boxShadow: 'none' }}
                  onClick={() => setShowDownloadPopup(true)}
                >
                  <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <img src={articleIcon} height={50} width={50} />
                  </div>
                  <BookTitleTypography variant="body2" isGridView={false} sx={{ flexGrow: 1 }}>
                    <p style={{ fontFamily: 'chanakyaUni', fontSize: 18, margin: 0, padding: 0, fontWeight: 600 }}>
                      {article.name}
                    </p>
                  </BookTitleTypography>
                </BookItemBox>
              </Grid>
            ))}
          </Grid>
        )}
      </MainContentBox>
    </Box>
  );
};

export default MobileArticlesPage;
